import offlineProgressSync from '../src/react/helpers/OfflineProgressSync';
import { updateProgress } from '../src/react/helpers/progressHelper';

export function illnessScriptProgressPercent(visitedCount, total) {
  return Math.floor(((visitedCount + 1) / (total + 1)) * 100);
}

export async function queuedVisitedScoredUids({ documentId, scored }) {
  let updates;
  try {
    updates = await offlineProgressSync.getQueuedUpdates();
  } catch {
    return [];
  }
  return updates
    .filter(
      (u) =>
        u.type === 'document_user_log' &&
        u.logType === 'OpenedSectionLog' &&
        String(u.documentId) === String(documentId) &&
        scored.includes(u.args?.node_uid),
    )
    .map((u) => u.args.node_uid);
}

function readScoredDataset(el) {
  try {
    return {
      scored: JSON.parse(el.dataset.illnessScriptScoredUids || '[]'),
      visited: JSON.parse(el.dataset.illnessScriptVisitedUids || '[]'),
    };
  } catch {
    return null;
  }
}

export function recordVisitedScoredUid(uid) {
  const el = document.querySelector('[data-illness-script-scored-uids]');
  if (!el || !uid) return;

  const parsed = readScoredDataset(el);
  if (!parsed) return;
  const { scored, visited } = parsed;

  if (!scored.includes(uid) || visited.includes(uid)) return;
  visited.push(uid);
  el.dataset.illnessScriptVisitedUids = JSON.stringify(visited);
}

export async function paintIllnessScriptProgressOffline({ documentId, extraUid } = {}) {
  const el = document.querySelector('[data-illness-script-scored-uids]');
  if (!el) return;

  const parsed = readScoredDataset(el);
  if (!parsed) return;
  const { scored, visited: serverVisited } = parsed;

  const queuedVisited = await queuedVisitedScoredUids({ documentId, scored });
  const visited = new Set([...serverVisited, ...queuedVisited]);
  if (extraUid && scored.includes(extraUid)) visited.add(extraUid);

  updateProgress({
    progress: illnessScriptProgressPercent(visited.size, scored.length),
    kind: 'illness_script',
  });
}
